var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointInvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 42,
    viewBox: "0 0 8 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 38C7.2 36.2327 5.76731 34.8 4 34.8C2.23269 34.8 0.8 36.2327 0.8 38C0.8 39.7673 2.23269 41.2 4 41.2C5.76731 41.2 7.2 39.7673 7.2 38ZM4.6 38L4.6 37.05L3.4 37.05L3.4 38L4.6 38ZM4.6 35.15L4.6 33.25L3.4 33.25L3.4 35.15L4.6 35.15ZM4.6 31.35L4.6 29.45L3.4 29.45L3.4 31.35L4.6 31.35ZM4.6 27.55L4.6 25.65L3.4 25.65L3.4 27.55L4.6 27.55ZM4.6 23.75L4.6 21.85L3.4 21.85L3.4 23.75L4.6 23.75ZM4.6 19.95L4.6 18.05L3.4 18.05L3.4 19.95L4.6 19.95ZM4.6 16.15L4.6 14.25L3.4 14.25L3.4 16.15L4.6 16.15ZM4.6 12.35L4.6 10.45L3.4 10.45L3.4 12.35L4.6 12.35ZM4.6 8.55L4.6 6.65L3.4 6.65L3.4 8.55L4.6 8.55ZM4.6 4.75L4.6 2.85L3.4 2.85L3.4 4.75L4.6 4.75ZM4.6 0.950001L4.6 5.24537e-08L3.4 -5.24537e-08L3.4 0.950001L4.6 0.950001Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointInvert);
export default __webpack_public_path__ + "static/media/pointInvert.b96f833e5295341e6bf0b700bdb2e706.svg";
export { ForwardRef as ReactComponent };